/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { DeviceTypes } from '@/types';
import { useAppData } from '@/hooks/useAppData';

type UseEagerLoadParams = {
  isEagerLoadDesktop?: boolean;
  isEagerLoadMobile?: boolean;
  isEagerLoadTablet?: boolean;
};

export const useEagerLoad = ({
  isEagerLoadDesktop: desktop,
  isEagerLoadMobile: phone,
  isEagerLoadTablet: tablet,
}: UseEagerLoadParams): boolean => {
  const { appData } = useAppData();
  const { deviceType } = appData;
  const cases: Partial<Record<DeviceTypes, boolean>> = {
    desktop,
    phone,
    tablet,
  };
  return cases[deviceType] || false;
};
